// extracted by mini-css-extract-plugin
export default {"colorSuccessMedium":"#7abe79","colorWarningMedium":"#f9d849","colorWarningDark":"#b68e3d","colorErrorMedium":"#e5133c","textHighlight":"styles_textHighlight__jZViH"};